import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Êtes-vous sûr ?',
    },
    [OrderMethod.Pickup]: 'Le client a-t-il déjà récupéré la commande ?',
    [OrderMethod.OnSite]: 'La commande a-t-elle été servie à table ?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'La commande a-t-elle déjà été livrée ?',
      [DeliveryProvider.UberDrive]: 'Le livreur a-t-il déjà récupéré la commande ?',
      [DeliveryProvider.FirstDelivery]: 'Le livreur a-t-il déjà récupéré la commande ?',
      [DeliveryProvider.WoltDrive]: 'Le livreur a-t-il déjà récupéré la commande ?',
    },
  },
  buttons: {
    cancel: 'Non, Annuler',
    confirm: 'Oui',
  },
};
